import { SECTION_EACH, SECTION_IF, SECTION_IF_WITH, SECTION_UNLESS } from '../../../config/types';

export default {
	each:    SECTION_EACH,
	if:      SECTION_IF,
	with:    SECTION_IF_WITH,
	unless:  SECTION_UNLESS
};
